module.exports = __webpack_public_path__ + "static/series_2250-a466977a1d3ea7c19e3c244b04a80c35.png";